import React, { useId, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { followUpShortcut } from '../utils/followUps';
import {taskTypeLabel} from './TaskSource';
import FormError from './FormError';

const FollowUpForm = ({ initialValue, onSubmit, onCancel, compact = false }) => {
  const { user } = useAuth();
  const id = useId();
  const [draft, setDraft] = useState({
    date: initialValue?.date || '', time: initialValue?.dateOnly ? '' : initialValue?.time?.slice(0, 5) || '', note: initialValue?.note || '', taskType:initialValue?.taskType||'follow_up',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const inputClass = 'w-full min-w-0 px-3 py-3 border border-gray-300 rounded-lg text-base bg-white';

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    setSaving(true);
    try {
      await onSubmit({...draft,dateOnly:!draft.time});
    } catch (err) {
      setError(err.response?.data?.error || err.response?.data?.errors?.[0]?.msg || 'Could not save task. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-3 rounded-lg border border-gray-200 bg-white p-4">
      <h3 className="font-semibold text-gray-900">{initialValue ? 'Edit task' : 'Add task'}</h3>
      <p className="text-xs text-gray-500">Times use {user?.timezone || 'Africa/Harare'}. Leave time blank for a date-only task; its reminder uses the workspace task settings.</p>
      <fieldset disabled={saving} className="space-y-3 min-w-0">
        <label className="block text-sm font-medium">Task type<select className={inputClass} value={draft.taskType} onChange={e=>setDraft({...draft,taskType:e.target.value})}>{['follow_up','confirmation','quotation','preparation'].map(type=><option key={type} value={type}>{taskTypeLabel(type)}</option>)}</select></label>
        <div className="flex flex-wrap gap-2" aria-label="Date shortcuts">
          {[[0, 'Today'], [1, 'Tomorrow'], [7, 'Next week']].map(([days, label]) => (
            <button key={label} type="button" className="px-3 py-2 rounded-lg bg-primary-50 text-primary-700 text-sm font-medium"
              onClick={() => setDraft({ ...draft, date: followUpShortcut(days, user?.timezone) })}>
              {label}
            </button>
          ))}
        </div>
        <div className={`grid grid-cols-1 ${compact ? '' : 'sm:grid-cols-2'} gap-3`}>
          <div className="min-w-0">
            <label htmlFor={`${id}-date`} className="block text-sm font-medium mb-1">Date *</label>
            <input id={`${id}-date`} type="date" required value={draft.date} className={inputClass}
              onChange={(e) => setDraft({ ...draft, date: e.target.value })} />
          </div>
          <div className="min-w-0">
            <label htmlFor={`${id}-time`} className="block text-sm font-medium mb-1">Time (optional)</label>
            <input id={`${id}-time`} type="time" value={draft.time} className={inputClass}
              onChange={(e) => setDraft({ ...draft, time: e.target.value })} />
          </div>
        </div>
        <div>
          <label htmlFor={`${id}-note`} className="block text-sm font-medium mb-1">Action</label>
          <textarea id={`${id}-note`} rows={2} maxLength={140} value={draft.note} className={inputClass}
            placeholder="What needs to be done?" aria-describedby={`${id}-count`}
            onChange={(e) => setDraft({ ...draft, note: e.target.value })} />
          <p id={`${id}-count`} className="text-xs text-gray-500 text-right">{draft.note.length}/140</p>
        </div>
        <FormError message={error} />
        <div className="flex flex-wrap gap-2">
          <button type="button" onClick={onCancel} className="flex-1 px-3 py-2 border rounded-lg">Cancel</button>
          <button type="submit" className="flex-1 px-3 py-2 rounded-lg bg-primary-600 text-white disabled:opacity-50">
            {saving ? 'Saving…' : initialValue ? 'Save changes' : 'Add task'}
          </button>
        </div>
      </fieldset>
    </form>
  );
};

export default FollowUpForm;
